var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__main header__wrapper"},[_c('div',{staticClass:"block_container"},[_c(_vm.headerMainComponent,{tag:"component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }